import { defineComponent } from 'vue';
export default defineComponent({
    props: {
        list: {
            type: Array,
            default() {
                return [];
            }
        },
        bannerStyle: {
            type: Object,
            default() {
                return {};
            }
        },
        listNum: {
            type: Number,
            default: 0
        },
        autoplay: {
            type: Number,
            default: 3000
        },
        numLayout: {
            type: String,
            default: 'rightTop'
        }
    },
    data() {
        return {
            observer: null
        };
    },
    mounted() {
        let dom = document.querySelector('html');
        if (dom !== null) {
            var rem = Number(localStorage.getItem('rem'));
            var size = parseFloat(dom.style.fontSize);
            var self = this;
            self.observer = new MutationObserver(() => {
                if (size === rem) {
                    self.$refs.swipe.resize();
                }
            });
            self.observer.observe(dom, { attributes: true });
        }
    },
    methods: {
        swipeChange(a) {
            this.$emit('swipeChange', a);
        }
    },
    unmounted() {
        this.observer.disconnect();
    }
});
